class StickyBuyButton extends HTMLElement {
  constructor() {
    super();

    this.activeClass = "wt-product__sticky-buy--show";
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    const addToCartModule = document.querySelector(".wt-product__add-to-cart");
    const btn = this.querySelector("button");

    const forObserver = document.querySelectorAll(
      ".wt-product__add-to-cart, .wt-footer, .wt-product__name",
    );

    let intersected = [];

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      addToCartModule.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting, target }) => {
        isIntersecting
          ? intersected.push(target)
          : (intersected = intersected.filter((item) => item !== target));
      });

      if (intersected.length) {
        this.classList.remove(this.activeClass);
      } else {
        this.classList.add(this.activeClass);
      }
    });

    forObserver.forEach((item) => {
      observer.observe(item);
    });
  }
}

customElements.define("sticky-buy-button", StickyBuyButton);

class MobileStickyCart extends HTMLElement {
  constructor() {
    super();
    this.activeClass = "mobile-sticky-cart--show";
    this.productForm = null;
    this.addToCartButton = null;
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    console.log('Mobile sticky cart: Initializing...');
    console.log('Mobile sticky cart: Current URL:', window.location.href);
    console.log('Mobile sticky cart: Body classes:', document.body.className);
    console.log('Mobile sticky cart: Data market:', document.body.dataset.market);
    
    // Check if we're on mobile (screen width < 900px)
    const isMobile = window.innerWidth < 900;
    console.log('Mobile sticky cart: Is mobile device:', isMobile, 'Screen width:', window.innerWidth);
    
    if (!isMobile) {
      console.log('Mobile sticky cart: Not on mobile device, hiding cart');
      this.style.display = 'none';
      return;
    }
    
    // Check if we're on the correct market (NL or BE)
    const isCorrect = this.isCorrectMarket();
    console.log('Mobile sticky cart: Market check result:', isCorrect);
    
    if (!isCorrect) {
      console.log('Mobile sticky cart: Not on NL/BE market, hiding cart');
      this.style.display = 'none';
      return;
    }

    // Find the main product form
    this.productForm = document.querySelector('form[action*="/cart/add"]');
    this.addToCartButton = this.querySelector('.mobile-sticky-cart__button');
    
    console.log('Mobile sticky cart: Product form found:', !!this.productForm);
    console.log('Mobile sticky cart: Add to cart button found:', !!this.addToCartButton);
    
    if (!this.productForm || !this.addToCartButton) {
      console.warn('Mobile sticky cart: Required elements not found');
      return;
    }

    // Force visibility and position for mobile product pages
    this.forceShow();
    
    // Handle button click
    this.addToCartButton.addEventListener('click', (e) => {
      e.preventDefault();
      this.handleAddToCart();
    });

    // Listen for variant changes to update price and availability
    this.listenForVariantChanges();
    
    // Listen for window resize to hide/show based on screen size
    window.addEventListener('resize', () => {
      const currentlyMobile = window.innerWidth < 900;
      if (!currentlyMobile) {
        console.log('Mobile sticky cart: Screen resized to desktop, hiding cart');
        this.hide();
        this.style.display = 'none';
      } else if (currentlyMobile && this.isCorrectMarket()) {
        console.log('Mobile sticky cart: Screen resized to mobile, showing cart');
        this.forceShow();
      }
    });
  }

  isCorrectMarket() {
    // Check various ways the market might be indicated
    const bodyElement = document.body;
    const htmlElement = document.documentElement;
    
    // Check data attributes (primary method now that we set it in layout)
    const marketData = bodyElement.dataset.market || htmlElement.dataset.market;
    if (marketData) {
      const market = marketData.toLowerCase();
      console.log('Mobile sticky cart: Market detected from data attribute:', market);
      if (market.includes('nl') || market.includes('be') || 
          market.includes('nederland') || market.includes('belgium') || 
          market.includes('belgie')) {
        return true;
      }
    }
    
    // Check CSS classes
    const classList = Array.from(bodyElement.classList);
    const hasMarketClass = classList.some(cls => 
      cls.includes('market-nl') || cls.includes('market-be') ||
      cls.includes('market-nederland') || cls.includes('market-belgium') ||
      cls.includes('market-belgie')
    );
    
    if (hasMarketClass) {
      console.log('Mobile sticky cart: Market detected from CSS classes');
      return true;
    }
    
    // Check URL or other indicators
    const url = window.location.href.toLowerCase();
    if (url.includes('/nl/') || url.includes('/be/') || 
        url.includes('market=nl') || url.includes('market=be')) {
      console.log('Mobile sticky cart: Market detected from URL');
      return true;
    }
    
    console.log('Mobile sticky cart: Market not detected, hiding cart');
    // Default to false (hide on other markets)
    return false;
  }

  show() {
    this.classList.add(this.activeClass);
    // Force visibility for correct markets
    this.style.display = 'block';
    this.style.opacity = '1';
    this.style.visibility = 'visible';
    // Update back to top button position
    document.body.classList.add('mobile-sticky-cart-visible');
  }

  forceShow() {
    console.log('Mobile sticky cart: Force showing cart');
    
    // Always show on mobile product pages for correct markets
    this.classList.add(this.activeClass);
    this.style.setProperty('display', 'block', 'important');
    this.style.setProperty('opacity', '1', 'important');
    this.style.setProperty('visibility', 'visible', 'important');
    this.style.setProperty('position', 'fixed', 'important');
    this.style.setProperty('bottom', '0', 'important');
    this.style.setProperty('left', '0', 'important');
    this.style.setProperty('right', '0', 'important');
    this.style.setProperty('z-index', '9999', 'important');
    this.style.setProperty('background', 'white', 'important');
    this.style.setProperty('border-top', '1px solid #eee', 'important');
    this.style.setProperty('box-shadow', '0 -1px 4px rgba(0,0,0,0.1)', 'important');
    
    // Update back to top button position
    document.body.classList.add('mobile-sticky-cart-visible');
    
    // Additional check to ensure it's visible
    setTimeout(() => {
      const computedStyle = window.getComputedStyle(this);
      const isVisible = computedStyle.display !== 'none';
      console.log('Mobile sticky cart: Visibility check after force show:', isVisible);
      console.log('Mobile sticky cart: Computed display:', computedStyle.display);
      console.log('Mobile sticky cart: Computed position:', computedStyle.position);
      console.log('Mobile sticky cart: Computed bottom:', computedStyle.bottom);
      console.log('Mobile sticky cart: Computed z-index:', computedStyle.zIndex);
      
      // If still not visible, try to override any potential conflicts
      if (!isVisible) {
        console.log('Mobile sticky cart: Still not visible, applying aggressive overrides');
        this.setAttribute('style', 'display: block !important; position: fixed !important; bottom: 0 !important; left: 0 !important; right: 0 !important; z-index: 9999 !important; opacity: 1 !important; visibility: visible !important; background: white !important; border-top: 1px solid #eee !important;');
      }
    }, 100);
  }

  hide() {
    this.classList.remove(this.activeClass);
    // Reset back to top button position
    document.body.classList.remove('mobile-sticky-cart-visible');
  }

  handleAddToCart() {
    if (!this.productForm) {
      console.error('Mobile sticky cart: No product form found');
      return;
    }

    // Get the form data
    const formData = new FormData(this.productForm);
    
    // Find the main add to cart button to get the correct variant ID
    const variantIdInput = this.productForm.querySelector('[name="id"]');
    
    console.log('Mobile sticky cart: Adding to cart with variant ID:', variantIdInput?.value);
    
    if (variantIdInput && variantIdInput.value) {
      // Show loading state
      this.setLoadingState(true);
      
      // Get cart drawer and sections to render (same as product-form.js)
      const cart = document.querySelector('cart-drawer');
      console.log('Mobile sticky cart: Cart drawer found:', !!cart);
      
      if (cart) {
        const sectionsToRender = cart.getSectionsToRender().map((section) => section.id);
        console.log('Mobile sticky cart: Sections to render:', sectionsToRender);
        formData.append("sections", sectionsToRender);
        formData.append("sections_url", window.location.pathname);
      }

      // Use fetchConfig helper if available (same as product-form.js)
      const config = typeof fetchConfig !== 'undefined' ? fetchConfig('javascript') : {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest',
        }
      };
      
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      if (config.headers['Content-Type']) {
        delete config.headers['Content-Type'];
      }
      config.body = formData;
      
      console.log('Mobile sticky cart: Submitting to:', window.routes?.cart_add_url);
      
      // Submit using same endpoint as main product form
      fetch(window.routes?.cart_add_url || '/cart/add', config)
      .then(response => {
        console.log('Mobile sticky cart: Response status:', response.status);
        return response.json();
      })
      .then(response => {
        console.log('Mobile sticky cart: Response data:', response);
        
        if (response.status) {
          // Handle error case
          console.error('Mobile sticky cart: Error adding to cart:', response.description);
          this.setLoadingState(false);
          return;
        }

        // Success - trigger proper cart update events and open drawer
        console.log('Mobile sticky cart: Successfully added to cart, triggering update');
        this.triggerCartUpdate(response);
        this.setLoadingState(false);
      })
      .catch(error => {
        console.error('Mobile sticky cart: Fetch error:', error);
        this.setLoadingState(false);
      });
    } else {
      console.log('Mobile sticky cart: No variant selected, scrolling to main form');
      // Scroll to the main product form if no variant is selected
      const mainProductSection = document.querySelector('.wt-product__add-to-cart, .main-product__buy-buttons--container');
      if (mainProductSection) {
        mainProductSection.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }
  }

  setLoadingState(loading) {
    const buttonText = this.addToCartButton.querySelector('.mobile-sticky-cart__button-text');
    if (loading) {
      this.addToCartButton.disabled = true;
      this.addToCartButton.classList.add('loading');
      if (buttonText) {
        // Store original text if not already stored
        if (!this.originalButtonText) {
          this.originalButtonText = buttonText.textContent;
        }
        buttonText.textContent = 'Adding...';
      }
    } else {
      this.addToCartButton.disabled = false;
      this.addToCartButton.classList.remove('loading');
      if (buttonText) {
        // Restore original text instead of hardcoded text
        if (this.originalButtonText) {
          buttonText.textContent = this.originalButtonText;
        } else {
          // Fallback - check availability from current state
          const isAvailable = !this.addToCartButton.hasAttribute('data-sold-out');
          const addToCartText = document.querySelector('.js-add-to-cart span')?.textContent || 'Add to cart';
          const soldOutText = 'Sold out';
          buttonText.textContent = isAvailable ? addToCartText : soldOutText;
        }
      }
    }
  }

  triggerCartUpdate(response) {
    console.log('Mobile sticky cart: Triggering cart update with response:', response);
    
    // Use the same pattern as product-form.js
    if (window.PUB_SUB_EVENTS && window.publish) {
      // Publish cart update event using the same pub/sub system
      const formData = new FormData(this.productForm);
      console.log('Mobile sticky cart: Publishing cart update event');
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
        source: "mobile-sticky-cart",
        productVariantId: formData.get("id"),
        cartData: response,
      });
    } else {
      console.log('Mobile sticky cart: PUB_SUB_EVENTS or publish not available');
    }

    // Open cart drawer the same way as product-form.js
    const cart = document.querySelector('cart-drawer');
    console.log('Mobile sticky cart: Cart drawer element found:', !!cart);
    console.log('Mobile sticky cart: Response has sections:', !!response?.sections);
    
    if (cart && response && response.sections) {
      const isClosedCart = !document.body.classList.contains('page-overlay-cart-on');
      console.log('Mobile sticky cart: Calling renderContents, isClosedCart:', isClosedCart);
      
      try {
        cart.renderContents(response, isClosedCart);
        console.log('Mobile sticky cart: renderContents called successfully');
      } catch (error) {
        console.error('Mobile sticky cart: Error calling renderContents:', error);
        // Fallback: trigger cart drawer refresh event
        document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
      }
    } else {
      console.log('Mobile sticky cart: Using fallback approaches');
      
      // Multiple fallback approaches to ensure cart gets updated and opened
      
      // 1. Trigger cart drawer refresh event
      document.dispatchEvent(new CustomEvent('cart-drawer:refresh', {
        detail: { response: response }
      }));
      
      // 2. Refresh cart contents by fetching sections manually
      if (cart) {
        const sectionsToRender = cart.getSectionsToRender();
        const sectionIds = sectionsToRender.map(s => s.id).join(',');
        
        fetch(`${window.Shopify.routes.root}?sections=${sectionIds}`)
          .then(response => response.json())
          .then(sections => {
            console.log('Mobile sticky cart: Fetched sections for manual refresh:', sections);
            const parsedState = { sections: sections };
            cart.renderContents(parsedState, true);
          })
          .catch(err => {
            console.error('Mobile sticky cart: Error fetching sections:', err);
            // Last resort: just open the cart drawer
            if (cart && typeof cart.toggleDrawerClasses === 'function') {
              console.log('Mobile sticky cart: Last resort - opening cart drawer manually');
              cart.toggleDrawerClasses();
            }
          });
      }
      
      // 3. Trigger generic cart update events for any listening components
      window.dispatchEvent(new CustomEvent('cart:updated'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  }

  listenForVariantChanges() {
    // Listen for variant selection changes
    document.addEventListener('variant:change', (event) => {
      this.updateAvailability(event.detail.variant);
    });

    // Also listen for direct form changes
    const variantSelects = document.querySelectorAll('[name="id"], .variant-selects select, .variant-radios input');
    variantSelects.forEach(select => {
      select.addEventListener('change', () => {
        // Small delay to allow other scripts to update first
        setTimeout(() => {
          this.updateFromCurrentSelection();
        }, 100);
      });
    });
  }

  updateAvailability(variant) {
    const buttonText = this.addToCartButton.querySelector('.mobile-sticky-cart__button-text');
    
    if (variant) {
      if (variant.available) {
        this.addToCartButton.disabled = false;
        this.addToCartButton.removeAttribute('data-sold-out');
        if (buttonText) {
          // Get text from main add to cart button to match translations
          const mainAddToCartText = document.querySelector('.js-add-to-cart span')?.textContent || 'Add to cart';
          buttonText.textContent = mainAddToCartText;
          this.originalButtonText = mainAddToCartText; // Update stored original text
        }
      } else {
        this.addToCartButton.disabled = true;
        this.addToCartButton.setAttribute('data-sold-out', 'true');
        if (buttonText) {
          // Get sold out text from main button or fallback
          const mainSoldOutText = document.querySelector('.product-form__submit span')?.textContent || 'Sold out';
          buttonText.textContent = mainSoldOutText;
          this.originalButtonText = mainSoldOutText; // Update stored original text
        }
      }
    }
  }

  updateFromCurrentSelection() {
    const variantIdInput = document.querySelector('[name="id"]');
    if (variantIdInput && variantIdInput.value) {
      // Try to get variant data from global product object or fetch it
      if (window.product && window.product.variants) {
        const variant = window.product.variants.find(v => v.id == variantIdInput.value);
        if (variant) {
          this.updateAvailability(variant);
        }
      }
    }
  }
}

customElements.define("mobile-sticky-cart", MobileStickyCart);

if (!customElements.get("gallery-fashion")) {
  customElements.define(
    "gallery-fashion",
    class GalleryFashion extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest("section");
        this.logoBanner = this;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.removeEventsWhenDesignMode();
      }

      addEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.addEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.addEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      removeEventsWhenDesignMode() {
        if (Shopify.designMode) {
          document.removeEventListener(
            "shopify:section:load",
            this.reinitAfterDelay,
          );
          document.removeEventListener(
            "shopify:section:unload",
            this.reinitAfterDelay,
          );
        }
      }

      reinitAfterDelay() {
        setTimeout(() => this.reinit(), 0);
      }

      isFirstSection() {
        const sectionWrapper = document.querySelector("#root");
        const firstSection = sectionWrapper.querySelector("section");
        this.section = this.closest("section");
        const currentSection = this.section;

        return firstSection === currentSection;
      }

      handleResize() {
        this.setTopMargin();
        this.positioningProductInfo();
      }

      observeHeader() {
        const header = document.querySelector(".wt-header");
        const activeTransparentClass = "wt-header--fashion-transparent";

        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
              } else {
                header.classList.add(activeTransparentClass);
              }
            });
          },
          { root: null, threshold: 0.05 },
        );

        observer.observe(this.querySelector(".wt-product__gallery"));
      }

      calculateOffset() {
        const header = document.querySelector("header");
        const headerHeight = header.offsetHeight;
        const offset =
          this.isTransparentHeaderEnabled() && this.isFirstSection()
            ? headerHeight
            : 0;

        return offset;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        if (offset) {
          this.section.style.marginTop = `-${offset}px`;
        } else {
          this.section.style.marginTop = 0;
        }
      }

      isTransparentHeaderEnabled() {
        const header = document.querySelector(".wt-header");
        return (
          header.dataset.transparent &&
          header.classList.contains("wt-header--v3")
        );
      }

      renderProgressBar() {
        const thumbsGallery = this.querySelector("[data-thumbs]");
        const progressBarElement = document.createElement("div");
        progressBarElement.classList.add("gallery-fashion__progress-bar");
        const progressBarIndicatorElement = document.createElement("div");
        progressBarIndicatorElement.classList.add(
          "gallery-fashion__progress-bar-indicator",
        );
        progressBarElement.appendChild(progressBarIndicatorElement);
        thumbsGallery.appendChild(progressBarElement);

        function updateProgressBar() {
          const images = this.querySelector("gallery-section");
          const progressBar = progressBarIndicatorElement;

          const scrolled = window.scrollY;
          const maxHeight = images.clientHeight - window.innerHeight;
          const scrollPercentage = (scrolled / maxHeight) * 100;

          const progressBarHeight = progressBarElement.clientHeight;
          const progressHeight = progressBar.clientHeight;
          const maxProgressTop = progressBarHeight - progressHeight;
          const progressTop = Math.min(
            (scrollPercentage / 100) * maxProgressTop,
            maxProgressTop,
          );

          progressBar.style.top = `${progressTop}px`;

          if (progressTop === maxProgressTop) {
            thumbsGallery.classList.add("finished");
          } else {
            thumbsGallery.classList.remove("finished");
          }
        }

        window.addEventListener("scroll", updateProgressBar.bind(this));

        function handleThumbsClick(event) {
          if (event.target.className === "wt-product__img") {
            const thumbnails = Array.from(
              event.currentTarget.querySelectorAll("img"),
            );
            const index = thumbnails.indexOf(event.target);

            const fullImage = this.querySelectorAll(
              ".wt-masonry__wrapper .wt-product__img, .wt-masonry__wrapper .wt-product__thumbnail-video",
            )[index];

            fullImage.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }

        thumbsGallery.addEventListener("click", handleThumbsClick.bind(this));
      }

      positioningProductInfo() {
        const productInfo = this.querySelector(".wt-product__main");
        const mediaDesktop = window.matchMedia("(min-width: 1200px)");

        if (mediaDesktop.matches) {
          productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
        }

        const resizeObserver = new ResizeObserver((entries) => {
          for (let entry of entries) {
            if (mediaDesktop.matches) {
              productInfo.style.top = `${Math.max((window.innerHeight - productInfo.offsetHeight) / 2, 0)}px`;
            }
          }
        });

        const observedElement = productInfo;
        resizeObserver.observe(observedElement);
      }

      attachEvents() {
        window.addEventListener("resize", this.handleResize.bind(this));
      }

      init() {
        this.reinitAfterDelay = this.reinitAfterDelay.bind(this);
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector(".swiper-wrapper--masonry").offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
          this.attachEvents();
        }

        this.renderProgressBar();
        this.positioningProductInfo();
        this.addEventsWhenDesignMode();
      }

      reinit() {
        if (this.isTransparentHeaderEnabled()) {
          const stickyHeaderThreshold = document.querySelector(
            ".sticky-header__threshold",
          );
          const isHeaderSticky =
            document.body.classList.contains("page-header-sticky");
          if (isHeaderSticky) {
            stickyHeaderThreshold.style.height = `${this.querySelector(".swiper-wrapper--masonry").offsetHeight}px`;
          }
          this.setTopMargin();
          this.observeHeader();
        }
        this.positioningProductInfo();
      }
    },
  );
}
